module.exports = __webpack_public_path__ + "img/recstation_logo_big.a5d69fdb.png";